// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import theme from './theme';
import {
  bodyStyles,
  inlineIcon,
  spacingReset,
  strikethrough,
  BodyStatus,
  StyledAnchorTag,
} from '../internal/internal-typography';
import type { BodyStatusType } from '../internal/internal-typography';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const PrimaryHeader = styled.h1`
  font-family: ${theme.fonts.serif};
  font-weight: ${theme.fontWeights.normal};
  font-size: 3rem;
  line-height: 3.25rem;
  color: ${theme.colors.primary};
  ${spacingReset}
  ${inlineIcon}
`;
PrimaryHeader.displayName = 'PrimaryHeader';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const SectionHeader = styled.h2`
  font-family: ${theme.fonts.sans};
  font-weight: ${theme.fontWeights.normal};
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${theme.colors.primary};
  ${spacingReset}
  ${inlineIcon}
`;
SectionHeader.displayName = 'SectionHeader';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const SubSectionHeader = styled.h3`
  font-family: ${theme.fonts.sans};
  font-weight: ${theme.fontWeights.normal};
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${theme.colors.secondary};
  ${spacingReset}
  ${inlineIcon}
`;
SubSectionHeader.displayName = 'SubSectionHeader';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.104.0. To view the error, delete this comment and run Flow. */
const Body = styled.p`
  ${bodyStyles}
`;
Body.displayName = 'Body';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const SecondaryBody = styled.p`
  font-family: ${theme.fonts.sans};
  font-weight: ${theme.fontWeights.normal};
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${theme.colors.primary};
  ${spacingReset}
  ${inlineIcon}
  ${strikethrough}
`;
SecondaryBody.displayName = 'SecondaryBody';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const TertiaryBody = styled.span`
  font-family: ${theme.fonts.sans};
  font-weight: ${theme.fontWeights.normal};
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${theme.colors.tertiary};
  ${spacingReset}
  ${inlineIcon}
`;

type LinkProps = {
  href: string,
  children: Node,
  rel?: string,
  target?: string,
};

const Link = React.forwardRef<LinkProps, StyledAnchorTag>((props, ref) => {
  return (
    <StyledAnchorTag {...props} ref={ref}>
      {props.children}
    </StyledAnchorTag>
  );
});
Link.displayName = 'Link';

const DangerLink = React.forwardRef<LinkProps, StyledAnchorTag>(
  (props, ref) => {
    return (
      <StyledAnchorTag {...props} ref={ref} danger>
        {props.children}
      </StyledAnchorTag>
    );
  }
);
DangerLink.displayName = 'DangerLink';

const ExternalLink = React.forwardRef<LinkProps, StyledAnchorTag>(
  (props, ref) => {
    return (
      <StyledAnchorTag
        target="_blank"
        rel="noopener noreferrer"
        {...props}
        ref={ref}
      >
        {props.children}
      </StyledAnchorTag>
    );
  }
);
ExternalLink.displayName = 'ExternalLink';

export {
  PrimaryHeader,
  SectionHeader,
  SubSectionHeader,
  Body,
  BodyStatus,
  SecondaryBody,
  TertiaryBody,
  Link,
  ExternalLink,
  DangerLink,
};
export type { BodyStatusType, LinkProps };
